import CommonAppbar from '../components/common/CommonAppbar';
import Filters from '../components/Filters';
import QuestionCard from '../components/QuesAndAns/QuestionCard';
import {useParams} from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import * as React from 'react';
import {useEffect} from 'react';
import Divider from '@mui/material/Divider';

export default function Hashtag() {
  let {hashtagId} = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [hashtagId])
  return <>

    <CommonAppbar isMainPage={false} pageHeader={`#${hashtagId}`}/>
    <Stack direction="row" spacing={2} sx={{mb: 2, mt: 1}}>
      <Avatar sx={{width: 80, height: 80}}>
        <Typography variant="h3" component="h3">
          #
        </Typography>

      </Avatar>

      <Stack direction="column" spacing={1}>
        <Typography variant="h4" component="h4">
          {hashtagId}
        </Typography>
        <Button size="small" variant="contained">Share hashtag</Button>
      </Stack>
    </Stack>
    <Divider/>
    <Filters/>
    <QuestionCard/>
  </>
}
